// Click on button "Our Reel" - opens modal with video
document.addEventListener('click', function (e) {
  var link = e.target.closest('a[data-modal="#CustomReelModal"]');
  if (link) {
    e.preventDefault();
    var modal = document.querySelector('#CustomReelModal');
    if (modal) {
      modal.setAttribute('open', '');
      
      const video = modal.querySelector('video');
      if (video) {
        if (video.readyState >= 2) {
          video.muted = false;
          video.play().catch(function(error) {
            video.muted = true;
            video.play().catch(function(error2) {
              console.log('Muted autoplay also failed:', error2);
            });
          });
        } else {
          // If video is not loaded, wait
          video.addEventListener('loadeddata', function() {
            video.muted = false;
            video.play().catch(function(error) {
              console.log('Autoplay after load failed:', error);
              video.muted = true;
              video.play().catch(function(error2) {
                console.log('Muted autoplay after load also failed:', error2);
              });
            });
          }, { once: true });
        }
      }
    }
  }
});

// Close modal
document.addEventListener('click', function (e) {
  var closeButton = e.target.closest('#ModalClose-reel');
  if (closeButton) {
    var modal = document.querySelector('#CustomReelModal');
    if (modal) {
      modal.removeAttribute('open');
        // Pauza video po zamknięciu
      const video = modal.querySelector('video');
      if (video) {
        video.pause();
      }
    }
  }
});

// Close modal by clicking on background
document.addEventListener('click', function (e) {
  var modal = document.querySelector('#CustomReelModal');
  if (modal && modal.hasAttribute('open') && e.target === modal) {
    modal.removeAttribute('open');
    const video = modal.querySelector('video');
    if (video) {
      video.pause();
    }
  }
});

// Close modal by pressing Escape
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    var modal = document.querySelector('#CustomReelModal');
    if (modal && modal.hasAttribute('open')) {
      modal.removeAttribute('open');
      const video = modal.querySelector('video');
      if (video) {
        video.pause();
      }
    }
  }
}); 